import BadgeNext from '@/gf/components/BadgeNext'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { CheckBadgeIcon, HeartIcon } from '@heroicons/react/20/solid'

export enum VendorBadgeType {
  MyDealer,
  ActiveOnGf,
  DraftVendor,
}

const badgesConfig: Record<VendorBadgeType, JSX.Element> = {
  [VendorBadgeType.MyDealer]: (
    <BadgeNext color="green">
      <HeartIcon className="inline-block h-3 w-3" /> Your Vendor
    </BadgeNext>
  ),
  [VendorBadgeType.DraftVendor]: (
    <BadgeNext color="yellow">
      <ExclamationTriangleIcon className="inline-block h-3 w-3" /> Finish setup before sending a
      request
    </BadgeNext>
  ),
  [VendorBadgeType.ActiveOnGf]: (
    <BadgeNext color="blue">
      <CheckBadgeIcon className="inline-block h-3 w-3" />
      Active
    </BadgeNext>
  ),
}

const VendorBadge = ({ type }: { type: VendorBadgeType }) => badgesConfig[type]

export default VendorBadge
